import { ViewAsUtils } from '@space-shell/common/utils/viewAs'
import { requester } from '@space-shell/config/request'

import { SectionsEndpoints } from './constants'
import type {
  SectionsResponse,
  SectionsParams,
  SectionItemsResponse,
  SectionProductDetail
} from './types'

class SectionService {
  static getSections = async (membershipId: string, params?: SectionsParams) => {
    const { data } = await requester.get<SectionsResponse>(
      SectionsEndpoints.sections(membershipId),
      {
        params
      }
    )

    return data
  }

  static getSectionsItems = async (membershipId: string, sectionId: string) => {
    const { data } = await requester.get<SectionItemsResponse>(
      SectionsEndpoints.sectionsItems(membershipId, sectionId),
      {
        headers: {
          ...ViewAsUtils.getHeaders()
        },
        params: {
          newCheckout: true
        }
      }
    )

    return data
  }

  static getSectionProductDetail = async (membershipSlug: string, sectionId: string) => {
    const { data } = await requester.get<SectionProductDetail>(
      SectionsEndpoints.sectionProductDetail(membershipSlug, sectionId)
    )

    return data
  }
}

export default SectionService
